import React from "react";
import HeaderDrawer from "../../../common/components/HeaderDrawer";
import ForgotPassword from "../../components/ForgotPassword";

const ForgotPasswordScreen = (props) => {
  return (
    <HeaderDrawer name="Esqueci minha senha">
      <ForgotPassword
        onRequestSend={(values) => props.forgotPassword(values)}
        {...props}
      />
    </HeaderDrawer>
  );
};

export default ForgotPasswordScreen;
